import { useRef } from 'react';

import { UpcomingEventCountdown } from '@ui/uikit/components/common/UpcomingEventCountdown';

import { useLastRoundInfo } from '../../../model/web3Raffle/api/useLastRoundInfo';

export const NextDrawCounter = () => {
  const { data: roundInfo, isFetching } = useLastRoundInfo();
  const value = Number(roundInfo?.closeTimestamp);
  // This ref is used to force a restart of the countdown when the `targetDate` prop changes.
  // React Countdown doesn't restart by default when the prop value updates,
  // so we use this ref to trigger a re-mount by changing the component's `key`.
  // https://www.npmjs.com/package/react-countdown#key
  const kerRef = useRef(1);

  return (
    <div className="text-h2-a flex gap-2 items-center max-xs-msq:flex-col max-xs-msq:gap-0">
      Next Draw in{' '}
      {isFetching ? (
        <span className="skeleton-text h-8 max-xl-msq:h-6 w-[138px] max-md-msq:w-[104px]" />
      ) : (
        <span className="text-base-text-pink">
          {roundInfo?.isEnded ? (
            'TBD'
          ) : (
            <UpcomingEventCountdown key={kerRef.current++} date={value} />
          )}
        </span>
      )}
    </div>
  );
};
